module.exports = __webpack_public_path__ + "static/media/error.d06318cf.svg";